// extracted by mini-css-extract-plugin
export default {"wrapper":"nVvGA","description":"Wknio","button":"nXl-E","skeleton-progress":"Io2W4"};